var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app" },
    [
      _c("router-view"),
      _c("QuattroComponent"),
      _c("AlertComponent"),
      _c("HintComponent"),
      _c("NoticeComponent"),
      _c("ProfileComponent"),
      _c("OfflineComponent")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }